import { api } from "../../../infra/api";
import { URLS } from "../../../infra/URLS";

export async function getProdutosEstoque(ProdutoId : number) {
  const { data } = await api.get(`${URLS.ESTOQUE_API}`, {
    params: {ProdutoId}
  });
  return data;
};
